import { render, staticRenderFns } from "./EventPopup.vue?vue&type=template&id=67e34fe7&"
import script from "./EventPopup.vue?vue&type=script&lang=js&"
export * from "./EventPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports